import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler, cnpj as toCnpj } from "utils";
import { ListCarriersActions } from "store/ducks/carriers";

import { Carrier } from "interfaces/carrier";

export function* listCarriersRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/carriers?${queryString}`);

    const comboOptions = data.map(({ id, trade_name, address_city, address_state, cnpj, carrier_code }: Carrier) => ({
      value: id,
      label: `${carrier_code ? `${carrier_code} - ` : ""}    ${query.withCNPJ && cnpj ? `${toCnpj(cnpj)} - ` : ''}${trade_name} - ${address_city}/${address_state}`,
    }));

    yield put(ListCarriersActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListCarriersActions.failure(errorMessage));
  }
}
